import React, { useState } from 'react';
import { useAuth } from './AuthProvider.js';
import LoginModal from './LoginModal.js';
import RegisterModal from './RegisterModal.js';
import './AccountButton.css';
import './themeToggle.css';

const AccountButton = ({ isDarkMode }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const handleLoginClick = () => {
    setShowLogin(true);
    setShowMenu(false);
  };

  const handleLogout = () => {
    logout();
    setShowMenu(false);
  };

  const closeModals = () => {
    setShowLogin(false);
    setShowRegister(false);
  };

  if (isAuthenticated && user) {
    return (
      <>
        <div className="account-container">
          <button
            className={`mode ${isDarkMode ? 'dark' : 'light'}`}
            onClick={() => setShowMenu(!showMenu)}
            title={`Signed in as ${user.displayName || user.email}`}
          >
            <span className='toolbar-emoji'>👤</span>
            <span className='toolbar-text'> {user.displayName || user.email.split('@')[0]}</span>
          </button>

          {showMenu && (
            <div className="account-menu">
              <div className="account-info">
                <div className="account-name">{user.displayName || user.email.split('@')[0]}</div>
                <div className="account-email">{user.email}</div>
              </div>
              <div className="account-divider"></div>
              <button className="account-menu-item" onClick={handleLogout}>
                Sign Out
              </button>
            </div>
          )}
        </div>

        {showMenu && (
          <div className="account-menu-overlay" onClick={() => setShowMenu(false)}></div>
        )}
      </>
    );
  }

  return (
    <>
      <button
        className={`mode ${isDarkMode ? 'dark' : 'light'}`}
        onClick={handleLoginClick}
        title="Sign in or create account"
      >
        <span className='toolbar-emoji'>👤</span>
        <span className='toolbar-text'> Account</span>
      </button>

      <LoginModal
        isOpen={showLogin}
        onClose={closeModals}
        onSwitchToRegister={() => {
          setShowLogin(false);
          setShowRegister(true);
        }}
      />

      <RegisterModal
        isOpen={showRegister}
        onClose={closeModals}
        onSwitchToLogin={() => {
          setShowRegister(false);
          setShowLogin(true);
        }}
      />
    </>
  );
};

export default AccountButton;
